var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKleeColIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.93 94.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.93,
    height: 94.93,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.19,
    y: 39.95,
    width: 6.56,
    height: 50.12,
    style: {
      fill: "#569b32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.75,42.63c0,2.69-6.56,2.69-6.56,0V33.52h6.56Z",
    style: {
      fill: "#487c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2,20.11a20.44,20.44,0,0,0,6.47,14.94,1.18,1.18,0,0,0,1.59,0,20.48,20.48,0,0,0,0-29.88,1.18,1.18,0,0,0-1.59,0A20.44,20.44,0,0,0,40.2,20.11Z",
    style: {
      fill: "#569b32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,27.37a19.34,19.34,0,0,0,.93-3.23l-5.87-8.45a1.11,1.11,0,0,0-2,0l-5.88,8.48a19.53,19.53,0,0,0,.89,3.12l5.19-4.61a1.05,1.05,0,0,1,1.47,0Z",
    style: {
      fill: "#99bc84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.71,28.09a20.38,20.38,0,0,0-14.93,6.48,1.15,1.15,0,0,0,0,1.58,20.45,20.45,0,0,0,29.87,0,1.15,1.15,0,0,0,0-1.58A20.4,20.4,0,0,0,62.71,28.09Z",
    style: {
      fill: "#569b32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,41.3a20.62,20.62,0,0,0,3.23.92l8.45-5.86a1.11,1.11,0,0,0,0-2L58.65,28.5a20.18,20.18,0,0,0-3.11.89l4.6,5.2a1.05,1.05,0,0,1,0,1.47Z",
    style: {
      fill: "#99bc84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,42.63a20.38,20.38,0,0,0,14.93-6.48,1.15,1.15,0,0,0,0-1.58,20.45,20.45,0,0,0-29.87,0,1.15,1.15,0,0,0,0,1.58A20.4,20.4,0,0,0,32.22,42.63Z",
    style: {
      fill: "#569b32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.48,29.42a20.62,20.62,0,0,0-3.23-.92L27.8,34.36a1.11,1.11,0,0,0,0,2l8.48,5.89a20.18,20.18,0,0,0,3.11-.89l-4.6-5.2a1.05,1.05,0,0,1,0-1.47Z",
    style: {
      fill: "#99bc84"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.05,21.13c-.23.1-.11.65.12,1.5a8.19,8.19,0,0,0-.86-.9C50.44,20,49.42,19.08,49,19.34c-.18.12-.07.53.17,1.14a5.39,5.39,0,0,0-1.65-.28,5.23,5.23,0,0,0-1.84.35c.26-.66.39-1.08.19-1.21-.4-.27-1.52.76-2.42,2.68a8.74,8.74,0,0,0-.79.91c.28-1,.45-1.69.19-1.8-.77-.32-3.32,4-2.63,9.43.61,4.76,4,8,4.67,7.83h0a5.23,5.23,0,0,0,5.23,0,3.58,3.58,0,0,0,1.41-1.07,9.06,9.06,0,0,0,1.81-2.61,12.59,12.59,0,0,0,1.3-4.14C55.37,25.13,52.83,20.81,52.05,21.13Z",
    style: {
      fill: "#ef89db"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKleeColIcon);
export default __webpack_public_path__ + "static/media/klee_col_icon.30f0a23547861d59de602d3717f8805c.svg";
export { ForwardRef as ReactComponent };